import Analytics from "analytics";
// @ts-ignore
import googleAnalytics from "@analytics/google-analytics";
// @ts-ignore
import googleAnalyticsV3Plugin from "@analytics/google-analytics-v3";
import { kubraEnrichEventsPlugin } from "./kubra-enrich-events-plugin";

export const createAnalyticsInstance = (
  appName: string,
  googleAnalyticsCode?: string,
  debug = false
) => {
  const isGAnalyticsV3 = googleAnalyticsCode?.startsWith("UA-");
  const isRunningJest = !!process.env.JEST_WORKER_ID;

  return Analytics({
    app: appName,
    plugins: [
      !isRunningJest && kubraEnrichEventsPlugin(),
      !isRunningJest &&
        !isGAnalyticsV3 &&
        googleAnalytics({
          measurementIds: [googleAnalyticsCode],
          debug,
        }),
      !isRunningJest &&
        isGAnalyticsV3 &&
        googleAnalyticsV3Plugin({
          trackingId: googleAnalyticsCode,
          debug,
        }),
    ].filter(Boolean),
    debug,
  });
};
